// Anchors nav
// =============================================================================
const vNode = window.vNode

export const a11yAnchors = () => {
  document.addEventListener('click', event => {
    if (
      !event.target ||
      !(event.target instanceof Element) ||
      !event.target.classList.contains('sr-skip-link')
    ) return

    const anchorID = event.target.getAttribute('href')
    if (!anchorID.startsWith('#')) return

    event.preventDefault()
    event.stopPropagation()

    const anchor = document.querySelector(anchorID)
    if (!anchor) return

    window.scrollTo({
      top: anchor.getBoundingClientRect().top + window.pageYOffset - window.innerWidth / 5,
      behavior: 'smooth'
    })
    anchor.focus()
  })
}

// .sr-only vNode
// =============================================================================
export const a11yTextVNode = (content, tag = 'span') => {
  return vNode.create(tag, { class: 'sr-only' }, [content])
}
